// extracted by mini-css-extract-plugin
export default {"FeedbackCard":"feedbackcard_FeedbackCard__Qxuqh","breakLine":"feedbackcard_breakLine__fqIMf"};